// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Signup__wrapper___3y3rX","logo":"Signup__logo___PIW0n","link":"Signup__link___3BoRj","button":"Signup__button___1bSbt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Signup/Signup.scss
// module id = eQX4
// module chunks = 0